// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { VisualshovelerGetString, TrendingSongsGetString, TopSongsGetString, TopPlaylistsGetString, TopAlbumsGetString, RecommendationPlaybackCarouselGetString, GenreCategoryFilterGetString, DescriptiveshovelerGetString, CategoryGetString, BrowseGetString, RecommendationTopRecommenderHeaderGetString, RecommendationFeaturedPlayButtonGetString } from './types.generated'

const visualshovelerLocales = ['en-US'] as const

export const getStringVisualshoveler: VisualshovelerGetString = i18nBundle('visualshoveler', visualshovelerLocales).getString

const trendingSongsLocales = ['en-US'] as const

export const getStringTrendingSongs: TrendingSongsGetString = i18nBundle('trendingSongs', trendingSongsLocales).getString

const topSongsLocales = ['en-US'] as const

export const getStringTopSongs: TopSongsGetString = i18nBundle('topSongs', topSongsLocales).getString

const topPlaylistsLocales = ['en-US'] as const

export const getStringTopPlaylists: TopPlaylistsGetString = i18nBundle('topPlaylists', topPlaylistsLocales).getString

const topAlbumsLocales = ['en-US'] as const

export const getStringTopAlbums: TopAlbumsGetString = i18nBundle('topAlbums', topAlbumsLocales).getString

const recommendationPlaybackCarouselLocales = ['en-US'] as const

export const getStringRecommendationPlaybackCarousel: RecommendationPlaybackCarouselGetString = i18nBundle('recommendationPlaybackCarousel', recommendationPlaybackCarouselLocales).getString

const genreCategoryFilterLocales = ['en-US'] as const

export const getStringGenreCategoryFilter: GenreCategoryFilterGetString = i18nBundle('genreCategoryFilter', genreCategoryFilterLocales).getString

const descriptiveshovelerLocales = ['en-US'] as const

export const getStringDescriptiveshoveler: DescriptiveshovelerGetString = i18nBundle('descriptiveshoveler', descriptiveshovelerLocales).getString

const categoryLocales = ['en-US'] as const

export const getStringCategory: CategoryGetString = i18nBundle('category', categoryLocales).getString

const browseLocales = ['en-US'] as const

export const getString: BrowseGetString = i18nBundle('browse', browseLocales).getString
export const getStringBrowse: BrowseGetString = getString

const recommendationTopRecommenderHeaderLocales = ['en-US'] as const

export const getStringRecommendationTopRecommenderHeader: RecommendationTopRecommenderHeaderGetString = i18nBundle('RecommendationTopRecommenderHeader', recommendationTopRecommenderHeaderLocales).getString

const recommendationFeaturedPlayButtonLocales = ['en-US'] as const

export const getStringRecommendationFeaturedPlayButton: RecommendationFeaturedPlayButtonGetString = i18nBundle('RecommendationFeaturedPlayButton', recommendationFeaturedPlayButtonLocales).getString

